import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const updateButtonSettings = (buttonThemeId: number) => returnAction(ActionEnum.SETTINGS_UPDATE_BUTTON_SETTINGS, buttonThemeId);
